import React, { Component, Fragment } from 'react'
import * as R from 'ramda'
import Input from 'components/fulcrum/input/Input'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  IconButton
} from 'react-toolbox'
import CSSModules from 'react-css-modules'
import styles from './styles.scss'

import { PROJECT_SPEC, NESTED_SPEC_ORDER } from './constants'

import T from 'i18n-react'

class VerticalTableInput extends Component {
  handleChange(index, type, val) {
    this.props.onChange(index, type, val)
  }

  getTableHead = () =>  {
    const { rowFormat, elementKey, parentColKey } = this.props

    return (
      <TableHead>
        {
          NESTED_SPEC_ORDER[elementKey][parentColKey].map((valueKey, idx) => {
            return (
              <TableCell key={idx}>
                {T.translate(`${PROJECT_SPEC}.${elementKey}.${parentColKey}.${valueKey}`)}
              </TableCell>
            )
          })
        }
      </TableHead>
    )
  }

  renderRows = () => {
    const { elementKey, parentColKey, values, rowFormat } = this.props

    return (
      values.map((row, idx) => {
        return (
          <TableRow key={`${elementKey}${idx}`}>
            {NESTED_SPEC_ORDER[elementKey][parentColKey].map((colKey) => {
              const { type, sources } = rowFormat[colKey]

              switch(type) {
                case 'string': return (
                  <TableCell key={colKey + idx}>
                    <Input type='text' value={row[colKey] || ''} onChange={this.handleChange.bind(this, idx, colKey)}/>
                  </TableCell>
                )
                case 'integer': return (
                  <TableCell key={colKey + idx}>
                    <Input type='number' value={row[colKey] || ''} onChange={this.handleChange.bind(this, idx, colKey)}/>
                  </TableCell>
                )
                case 'drop_down': return (
                  <TableCell key={colKey + idx}>
                    <Dropdown source={sources} value={row[colKey] || ''} onChange={this.handleChange.bind(this, idx, colKey)}/>
                  </TableCell>
                )
              }
            })}
            {this.getTableRowCellsDel(idx)}
          </TableRow>
        )


      })
    )
  }

  getAddButton = () => {
    const {
        onAdd,
        elementKey,
        parentColKey
    } = this.props
    
    return (
      <Button
        icon='add'
        label={T.translate(`${PROJECT_SPEC}.${elementKey}.${parentColKey}.add`)}
        flat
        primary
        onClick={ onAdd }
        styleName="nestedeAddBtn"
        theme={styles}
      />
    )
  }

  getTableRowCellsDel = (idx) => {
    const {
      onRemove
    } = this.props

    return (
        <TableCell styleName="deleteBtn" theme={styles}>
            <IconButton icon='delete' onClick={onRemove.bind(this, idx)} primary />
        </TableCell>
    )
  }

    
  render() {
    const { title } = this.props

    return (
      <div styleName='configTable'>
            <div><span>{title}</span></div>
            <div styleName='configTableContent'>
              <Table theme={styles} selectable={false}>
                {this.getTableHead()}
                {this.renderRows()}
              </Table>
              {this.getAddButton()}
              </div>
        </div>
    )
  }
}

export default CSSModules(VerticalTableInput, styles)
